import { getClasses } from '../../utils/styler';

const InputField = ({ onChangeText, disabled, ...props }) => (
	<input className={getClasses({ ...props }, {
		'af-input': true
	})} disabled={disabled} onChange={onChangeText} {...props} />
);

export default InputField;
